import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { auth } from '../api/index.js';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => auth.me(),
    retry: 2,
    retryDelay: 1000,
    staleTime: 30 * 60 * 1000,  // 30 min — don't re-check unless truly stale
    gcTime: 60 * 60 * 1000,     // 1 hr cache
  });
}

/** Server sets enableEdit from ENABLE_EDIT (catalog PATCH). */
export function useEnableEdit(): boolean {
  const { data } = useMe();
  return data?.enableEdit === true;
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => auth.logout(),
    onSuccess: () => qc.setQueryData(['me'], null),
  });
}
